import { Component, OnInit } from '@angular/core';
import { read, write, utils } from 'xlsx';

import { SalesLeadsService } from '../services/sales-leads.service';

@Component({
  selector: 'app-leads-upload',
  templateUrl: './leads-upload.component.html',
  styleUrls: ['./leads-upload.component.css']
})
export class LeadsUploadComponent implements OnInit {

  arrayBuffer: any;
  file: File;

  constructor(private sls: SalesLeadsService) { }

  ngOnInit() {
  }

  onFileAdded(event){
    console.log("File upload complete.");
    this.file= event.target.files[0];
  }

  upload(){
    let fileReader = new FileReader();
        fileReader.onload = (e) => {
            this.arrayBuffer = fileReader.result;
            var data = new Uint8Array(this.arrayBuffer);
            var arr = new Array();
            for(var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
            var bstr = arr.join("");
            var workbook = read(bstr, {type:"binary"});
            var first_sheet_name = workbook.SheetNames[0];
            var worksheet = workbook.Sheets[first_sheet_name];
            console.log(utils.sheet_to_json(worksheet,{raw:true}));
            this.addNewLeads(utils.sheet_to_json(worksheet,{raw:true}));
        }
        fileReader.readAsArrayBuffer(this.file);
  }

  addNewLeads(leads){
    for(var j=0; j != leads.length; j++){
      console.log("Row id is", leads[j].name, leads[j].phone, leads[j].email);
      console.log("Data is ", leads[j]);
      if(leads[j].phone === undefined){
        console.log("Phone number is required.");
        continue;
      }
      this.sls.addNewLead(leads[j]);
    }
  }

}
